<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.692383" width="24" height="24" rx="12" fill="#27A6E5"/>
    <path
        d="M18.6924 6.45167L16.557 18.2192C16.557 18.2192 16.2582 19.0351 15.4374 18.6438L10.5104 14.5144L10.4875 14.5023C11.1531 13.849 16.3138 8.777 16.5394 8.54709C16.8885 8.19102 16.6718 7.97905 16.2664 8.24802L8.64326 13.5397L5.70228 12.4581C5.70228 12.4581 5.23946 12.2781 5.19494 11.8868C5.14983 11.4949 5.71752 11.2829 5.71752 11.2829L17.707 6.14171C17.707 6.14171 18.6924 5.66845 18.6924 6.45167Z"
        fill="#FEFEFE"/>
  </svg>
</template>